/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import { IStatusRemessaRepository } from "@/interface/status-remessa";

const statusRemessaRepository: IStatusRemessaRepository = {
  async handleStatusRemessa(accessToken, id_remessa, payload) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const customers = await Instance.post(`remessas/${id_remessa}/status`, payload, {
      headers: {
        "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return customers?.data;
  },
};

/**
 * EXPORTS
 */
export { statusRemessaRepository };
